<!--
Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

@if (state === 'good') {
    <div>
        <div mat-dialog-title class="font-header6">Success</div>
        <div mat-dialog-content class="invitation-result-content font-body2">
            You have successfully joined the tester team. Stay tuned for further communication about any upcoming tests.
        </div>
        <div mat-dialog-actions [align]="'end'">
            <button mat-flat-button class="font-button2" (click)="onClick()">OK</button>
        </div>
    </div>
}
@if (state === 'error') {
    <div>
        <div mat-dialog-title class="font-header6">Error joining the tester team</div>
        <div mat-dialog-content class="invitation-result-content font-body2">
            {{ errorText }}
        </div>
        <div mat-dialog-actions [align]="'end'">
            <button mat-flat-button class="font-button2" (click)="onClick()">OK</button>
        </div>
    </div>
}
